<div class="page_auth">

  <div class="auth_top">

    <img src="/icons/logo.png" alt="Secur Logo"/>

    <h2>Securpro</h2>

    <h3>DEFINIR PALAVRA-PASSE</h3>

  </div>

  <form
    [formGroup]="form"
    class="form_auth"
    (ngSubmit)="submit()"
    autocomplete="off"
  >

    <div class="info-note" *ngIf="preenchidoPorLink">

      <i class="pi pi-info-circle"></i>

      <span>
        Dados pré-preenchidos a partir do link recebido.
        Defina a sua nova palavra-passe.
      </span>

    </div>

    <div class="input_camp">

      <label for="username">Utilizador</label>

      <div class="insert_camp">

        <i class="pi pi-user field-icon"></i>

        <input
          id="username"
          type="text"
          placeholder="NIF ou e-mail"
          formControlName="username"
          autocomplete="off"
          spellcheck="false"
        />

      </div>

      <small
        class="error"
        *ngIf="
          f['username'].touched &&
          f['username'].errors?.['required']
        "
      >
        O utilizador é obrigatório.
      </small>

    </div>

    <div class="input_camp">

      <label for="passwordTemporaria">
        Palavra-passe Temporária
      </label>

      <div class="insert_camp">

        <i class="pi pi-lock field-icon"></i>

        <input
          id="passwordTemporaria"
          type="password"
          placeholder="Palavra-passe recebida"
          formControlName="passwordTemporaria"
          autocomplete="new-password"
        />

      </div>

      <small
        class="error"
        *ngIf="
          f['passwordTemporaria'].touched &&
          f['passwordTemporaria'].errors?.['required']
        "
      >
        A palavra-passe temporária é obrigatória.
      </small>

    </div>


    <div class="input_camp">

      <label for="novaPassword">
        Nova Palavra-passe
      </label>

      <div class="insert_camp">

        <i class="pi pi-key field-icon"></i>

        <input
          id="novaPassword"
          #novaPasswordInput
          type="password"
          placeholder="Mínimo 8 caracteres"
          formControlName="novaPassword"
          autocomplete="new-password"
        />

      </div>

      <small
        class="error"
        *ngIf="
          f['novaPassword'].touched &&
          f['novaPassword'].errors?.['required']
        "
      >
        A nova palavra-passe é obrigatória.
      </small>

      <small
        class="error"
        *ngIf="
          f['novaPassword'].touched &&
          f['novaPassword'].errors?.['minlength']
        "
      >
        A nova palavra-passe deve ter pelo menos 8 caracteres.
      </small>

    </div>

    <div class="input_camp">

      <label for="confirmarNovaPassword">
        Confirmar Nova Palavra-passe
      </label>

      <div class="insert_camp">

        <i class="pi pi-key field-icon"></i>

        <input
          id="confirmarNovaPassword"
          type="password"
          placeholder="Repita a nova palavra-passe"
          formControlName="confirmarNovaPassword"
          autocomplete="new-password"
        />

      </div>

      <small
        class="error"
        *ngIf="
          f['confirmarNovaPassword'].touched &&
          f['confirmarNovaPassword'].errors?.['required']
        "
      >
        A confirmação é obrigatória.
      </small>

      <small
        class="error"
        *ngIf="
          f['confirmarNovaPassword'].touched &&
          f['confirmarNovaPassword'].errors?.['passwordMismatch']
        "
      >
        As palavras-passe não coincidem.
      </small>

    </div>

    <button
      type="submit"
      class="btn-entrar"
      [disabled]="loading"
    >

      <span *ngIf="!loading">

        <i class="ri-shield-check-line"></i>

        Definir Palavra-passe

      </span>


      <span *ngIf="loading">

        <i class="ri-loader-4-line spin"></i>

        A processar...

      </span>

    </button>

    <a routerLink="/login" class="link-primeiro-acesso">Voltar ao login</a>

    <div class="atencion">

      <span></span>

      <p>
        APENAS PESSOAL AUTORIZADO
      </p>

      <span></span>

    </div>

  </form>

</div>